export default {
  header: "Confirm Request",
  description:
    "Review and confirm the prescription below. Once you’ve finished filling out the required fields, you can send it to the Covetrus Online Pharmacy.",
  updateWeightSuccessful: "Successfully updated patient weight.",
  updateWeightFailure: "Failed to update patient weight.",
  fetchApprovalsFailure: "Error fetching approvals.",
  fetchRenewalsFailure: "Error fetching renewals.",
  fetchBaseProductFailure: "Error fetching base product details.",
};
